// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"style_btn-wrapper__Bl8EY","circleButtons":"style_circleButtons__SQjPL","status":"style_status__qnNBA"};